//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.ShipDesign.TransFrameListItemBuilderList.js";
import "../no/Features.js";
import "../no/ObjectList.js";
let d=[[[0,"AttribName",1,0],[0,"AttribRef",1,0],[0,"FeatureNameSuffix",1,0],[0,"FrameFeatureType",1,0],[0,"NegateFrame",1,0],[1,"TransFrameNegList",0,"Features.ShipDesign.TransFrameListItemBuilderList",0],[1,"TransFramePosList",0,"Features.ShipDesign.TransFrameListItemBuilderList",0]],[[[],"CreateTransFrameListItem",{R_:{listItem:"Features.ShipDesign.TransFrameListItemBuilder"}},0,0]],[]];
SPLM.Features.ShipDesign.TransFrameBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.TransFrameBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.TransFrameBuilder.FrameFeatureTypes = Object.freeze({
    "Insert" : "Insert", "Transverse" : "Transverse", "LongitudnalY" : "LongitudnalY", "LongitudnalZ" : "LongitudnalZ"});

export default SPLM;